import { render, staticRenderFns } from "./ProductShowData.vue?vue&type=template&id=4d236593"
import script from "./ProductShowData.vue?vue&type=script&lang=js"
export * from "./ProductShowData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports